import { TWO_D_REPORT_RIGHT_COLUMN_ID } from '../config';

export const is2DReportRightColumnScrollable = () => {
  const rightColumn = document.getElementById(TWO_D_REPORT_RIGHT_COLUMN_ID);

  return !!rightColumn && getComputedStyle(rightColumn).overflowY !== 'visible';
};
